/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiGetContentByKeyQueryResponse, ContentAiGetContentByKeyPathParams, ContentAiGetContentByKey401, ContentAiGetContentByKey403 } from "../models/ContentAiGetContentByKey";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { contentAiGetContentByKey } from "../axios/contentAiGetContentByKey";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const contentAiGetContentByKeyQueryKey = (key: ContentAiGetContentByKeyPathParams["key"]) => ["api-v2", { url: '/content-ai/v1/contents/key/:key', params: {key:key} }] as const

export type ContentAiGetContentByKeyQueryKey = ReturnType<typeof contentAiGetContentByKeyQueryKey>

export function contentAiGetContentByKeyQueryOptions(key: ContentAiGetContentByKeyPathParams["key"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = contentAiGetContentByKeyQueryKey(key)
        return queryOptions<ContentAiGetContentByKeyQueryResponse, ResponseErrorConfig<ContentAiGetContentByKey401 | ContentAiGetContentByKey403>, ContentAiGetContentByKeyQueryResponse, typeof queryKey>({
         enabled: !!(key),
         queryKey,
         queryFn: async ({ signal }) => {
            return contentAiGetContentByKey(key, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Keys are used to identify fragments based on an external ID (e.g.: `FRAGMENT:123456`)
 * @summary Get content by key
 * {@link /content-ai/v1/contents/key/:key}
 */
export function useContentAiGetContentByKey<TData = ContentAiGetContentByKeyQueryResponse, TQueryData = ContentAiGetContentByKeyQueryResponse, TQueryKey extends QueryKey = ContentAiGetContentByKeyQueryKey>(key: ContentAiGetContentByKeyPathParams["key"], options: 
{
  query?: Partial<QueryObserverOptions<ContentAiGetContentByKeyQueryResponse, ResponseErrorConfig<ContentAiGetContentByKey401 | ContentAiGetContentByKey403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? contentAiGetContentByKeyQueryKey(key)
         

         const query = useQuery({
          ...contentAiGetContentByKeyQueryOptions(key, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ContentAiGetContentByKey401 | ContentAiGetContentByKey403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}